import React, { Suspense, useEffect, useState } from 'react'
import { HashRouter, Route, Switch, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { Credentials, StringTranslations } from '@crowdin/crowdin-api-client'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import Header from '../components/Header'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import AddLiquidity from './AddLiquidity'
// import Staking from './Staking'
// import Farm from './Farm'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity
} from './AddLiquidity/redirects'
import MigrateV1 from './MigrateV1'
import MigrateV1Exchange from './MigrateV1/MigrateV1Exchange'
import RemoveV1Exchange from './MigrateV1/RemoveV1Exchange'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
// import Farm from './Farm'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'
import { RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'
import { EN } from '../constants/localisation/languageCodes'
import { LanguageContext } from '../hooks/LanguageContext'
import { TranslationsContext } from '../hooks/TranslationsContext'
import { allLanguages } from '../constants/localisation/languageCodes'
import cookie from '../utils/cookie'
import { I18nProvider } from '../i18n/i18n-react'
import BgIcon from '../assets/images/bg_black.png'
import BgIconPc from '../assets/images/Box.jpg'
import { isMobile } from 'react-device-detect'
import { SwapPoolTabs } from '../components/NavigationTabs'
import CoyIcon from '../assets/images/coy_logo.png'
import LngSHome from '../components/Header/LngSHome'
import useHTPrice from '../hooks/useHtPrice'
import IconCat from "../assets/images/icon_cat.png"
import IconBubble from '../assets/images/icon_bubble.png'
import IconArrow from "../assets/images/icon_arrow_right.png"
import { bottom } from 'styled-system'
import Icon1 from '../assets/tabbar/icon_1.png'
import Icon2 from '../assets/tabbar/icon_2.png'
import Icon3 from '../assets/tabbar/icon_3.png'
import Icon4 from '../assets/tabbar/icon_4.png'
import Icon5 from '../assets/tabbar/icon_5.png'
import { ethers } from 'ethers'
import Pledge from './Pledge'
import PledgeHome from './Pledge/home'
import Market from './Pledge/market'
import { isNewPage } from '../utils'
import Detail from './Pledge/detail'
import Bag from './Pledge/bag'
import Order from './Pledge/order'
import NftLog from './Pledge/nft-log'
import HistoryComp from './Pledge/history'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  // overflow-x: hidden;
`

const HeaderContainer = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap}
  width: 100%;
  justify-content: space-between;
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 160px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
      padding: 16px;
  `};

  z-index: 1;
`

const Marginer = styled.div`
  margin-top: 5rem;
`

const PageBg = styled.img`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
`

const Menu = styled.div`
  position: absolute;
  bottom: 48px;
  right: -4px;
  width: 110px;
  // height: 144px;
  padding: 16px 0;
  background-color: rgb(33, 52, 62);
  box-shadow: rgba(0, 0, 0, 0.01) 0px 0px 1px, rgba(0, 0, 0, 0.04) 0px 4px 8px, rgba(0, 0, 0, 0.04) 0px 16px 24px, rgba(0, 0, 0, 0.01) 0px 24px 32px;
  border: 1px solid rgb(64, 68, 79);
  border-radius: 5px;
`

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  width: 110px;  
  height: 19px;
  padding: 0 16px;
`

const MenuItemTitle = styled.div`
  flex: 1;
  text-align: right;
  color: white;
  font-weight: bold;
  font-size: 13.5px;
`

// const LogoTitle = styled.img`
//   width: 350px;
//   margin-top: 20px;
// `

// const BackImage = styled.img`
//   position: fixed;
//   top: 5%;
//   width: 100%;
// `

export const GlobalPoolList = [{
  src: "data:image/png;base64,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",
  addr: '0x34e249f87a2753928397615fD3b6107ee0c0f511',
  coreName: 'VPN',
  name: '单币挖矿',
  banner: 'https://ipfs.gateway.fatsale.finance/ipfs/QmbTJKFntG32paJRaqayuHrGonFfC2s6FnXgTYdjrQzmq8',
}, {
  src: "data:image/png;base64,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",
  addr: '0x911d54D0607c1b9E17B39Dce6fd6A30f78f6caeE',
  coreName: 'VPN',
  name: 'LP挖矿',
  banner: 'https://ipfs.gateway.fatsale.finance/ipfs/QmbTJKFntG32paJRaqayuHrGonFfC2s6FnXgTYdjrQzmq8',
}]

function Tabbar() {

  const [showMenu, setShowMenu] = useState(false)
  const [menuList, setMenuList] = useState(GlobalPoolList)
  const location = useLocation()

  if (isNewPage(location.pathname)) {
    return null
  }

  return <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: '49px',
    padding: '0 20px',
    background: 'rgba(33, 52, 62, 1)',
    zIndex: 2
  }}>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 58,
      color: 'rgba(227, 245, 246)',
      fontSize: '11px',
      fontWeight: 'bold'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 24,
        height: 24,
      }}>
        <img style={{
          width: 24
        }} src={Icon1} alt="" />
      </div>
      <div>交易</div>
    </div>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 58,
      color: 'rgb(164, 193, 202)',
      fontSize: '11px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 24,
        height: 24,
      }}>
        <img style={{
          width: 22
        }} src={Icon2} alt="" />
      </div>
      <div>赚取</div>
    </div>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 58,
      color: 'rgb(164, 193, 202)',
      fontSize: '11px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 24,
        height: 24,
      }}>
        <img style={{
          width: 24
        }} src={Icon3} alt="" />
      </div>
      <div>Lend</div>
    </div>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 58,
      color: 'rgb(164, 193, 202)',
      fontSize: '11px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 24,
        height: 24,
      }} onClick={() => {
        window.location.href = '/#/home'
      }}>
        <img style={{
          width: 22
        }} src={Icon4} alt="" />
      </div>
      <div>Nft Amm</div>
    </div>
    <div style={{
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 58,
      color: 'rgb(164, 193, 202)',
      fontSize: '11px'
    }} onClick={() => {
      console.log(showMenu)
      setShowMenu(old => !old)
    }}>
      {/* {showMenu && <div
        style={{
          position: 'absolute',
          bottom: 49,
          right: 0,
          width: 100,
          height: 100,
          backgroundColor: 'rgb(33, 52, 62)',
          boxShadow: 'rgba(0, 0, 0, 0.01) 0px 0px 1px, rgba(0, 0, 0, 0.04) 0px 4px 8px, rgba(0, 0, 0, 0.04) 0px 16px 24px, rgba(0, 0, 0, 0.01) 0px 24px 32px',
          border: '1px solid rgb(64, 68, 79)'
        }}
      > */}
      {showMenu && <Menu>
        {menuList.map((item, index) => {
          return <>
            <MenuItem onClick={() => {
              window.location.href = '/#/pledge?addr=' + item.addr
            }}>
              <img style={{
                width: 16,
                height: 16
              }} src={item.src}></img>
              <MenuItemTitle>{item.name}</MenuItemTitle>
            </MenuItem>
            {index != menuList.length - 1 && <div style={{
              height: 12
            }}></div>}
          </>
        })}
        {/* <MenuItem onClick={() => {
          window.location.href = '/#/pledge'
        }}>
          <img style={{
            width: 16,
            height: 16
          }} src="data:image/png;base64,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"></img>
          <MenuItemTitle>挖矿</MenuItemTitle>
        </MenuItem>
        <div style={{
          height: 12
        }}></div>
        <MenuItem onClick={() => {
          window.location.href = '/#/pledge'
        }}>
          <img style={{
            width: 16,
            height: 16
          }} src="data:image/png;base64,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"></img>
          <MenuItemTitle>YFI挖矿</MenuItemTitle>
        </MenuItem>
        <div style={{
          height: 12
        }}></div>
        <MenuItem onClick={() => {
          window.location.href = '/#/pledge'
        }}>
          <img style={{
            width: 16,
            height: 16
          }} src="data:image/png;base64,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"></img>
          <MenuItemTitle>BTC挖矿</MenuItemTitle>
        </MenuItem>
        <div style={{
          height: 12
        }}></div>
        <MenuItem onClick={() => {
          window.location.href = '/#/pledge'
        }}>
          <img style={{
            width: 16,
            height: 16
          }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAABIBJREFUeF7tnMt13DYUhn8w2WS8iFKBlaVNnWOoAIszFUSqwFIFtiqwU4HlCiRVYLmC4cgFGDknIy816UBa2M4i4s0BZijzAZDgyyJnwC0BEPfjj0vwAhcM7iokwByfYgIOUIlCHCAHqJkTKVUQv55u4Zv3AhHtg7Fxs8c9cG2iGzCEIHYhdoJzm94UAuLzKQfYe4Bt2zQ2qDJEIR7Rgfh9clPUbyOgJRzv06CMrtxZWmBEu0WQtIDUsPrCrsHYVuVnDq0CUSh2xhNTt/WAri5fgehtvhLdAkwMjUGiv4G+79Gu8Cdau/SA5rMQQLoxwrnYCQ4HDAerkRGCsWcZO/4UfvBGZ5sJEKUL063wx2sx3Ay+dSb8QPuFtgQEYwNDVBSfzzICMNvnAC3fsFNQUulOQSXj3gFygJp9GpyCnIKcgpoRcApqxs/5IKcgp6BmBJyCmvFzPmjdFcQ/T7cReS8q62QUvSsLwss2B68g/vnjGFE0rQaIHQl/78ymzgYCsoezgQqqBmfDAFWHMwhAq9WF92B0rFtuUff//ZnjLjoEg8FZ14PTe0DK+K9sCjAOtVZOEy2k+eUhQKd6p1sfTq8BpeDElmsg8Q7h9BaQFo4GUtdwegmoEE4KEjsBoF3hBJoNq96ualjBKZ3dtQenVwoqhqM2QvxayqZF5cTP6sVMusTn/IVHNMYX78T8GZfmtKuc3gCygRP/VPK/Z2d6SN3A6c0Q0xpOpJST/ePOl+0OzgqQ3N6TvITwg1e64d7p5oWU4QY497K/V1K3cMp9XrpEp4DU25KGg7hOOdnOyjCHePI8+3ar2tRq+c4BKUjX0y2bQFarlrXU2A8B1FJfH6QZB6gE+0YA4leX+/jlLqwzzAcLiM9nbwC2KItDf9+0SRfCHx8UCSaevwl/vBuXGzggvAbhROwExybD+Tz8pGJP6jJPIZJpF8IP7rkMH5AynC4woqPcBHQ+k9GBl/fwZOzpJ9oVTyaLJFA1BKPoNM4sWENACpKARwex8ealIxLJIcSvZi+lClPT6vVT0Mq8VXQSIyxKck3Uzno+D08BlsseWFMFJTVA4rvfMXknWpjSvDYAULM55QYCon8A9tgW24YBoluMaBtfPRnOeG0DabMAMXYgnu5dLCMLodCkQuWYrS8gxo5BkZxhx7Hud8lA2HJbjUwIXN0nnINB5uOmcuMsAIU3uYD6KPqtzr+MjaTrlFn+amSGjOdNgP8WuGNKMdroZbwoydixeLp3wjXJgxaAZvIBf6Q7Lj+ddGRKXaxjZJM6JkAy4Lb8p8K2qa/JwFxNQEXr4k3Mql03l89VBKjKU2oBquLQqnSmQdkeAlruwpAOzXr+0ABAWdX+AVIqUpA86Y8M6dRldrV2Pw9Im7pOAoTCkxQ0PeLZ8wFKnXS2kVXQaR/AQ53dkVu36vBkiA/CD6St6io93KQ1DXTQkM7BNn6M502SS08DB6QOXwntNkFYoNMcnjBoQAk/KY/SkMf3ZE9UsKCiinwAY2fxL0my0uAB2RKoW84BKiHnAJUA+h9sHat2u0PIEwAAAABJRU5ErkJggg=="></img>
          <MenuItemTitle>私募</MenuItemTitle>
        </MenuItem> */}
      </Menu>}
      <img style={{
        width: 24,
        height: 24
      }} src={Icon5} alt="" />
      <div>挖矿</div>
    </div>
  </div>
}

export default function App() {
  const [selectedLanguage, setSelectedLanguage] = useState<any>(undefined)
  const [translatedLanguage, setTranslatedLanguage] = useState<any>(undefined)
  const [translations, setTranslations] = useState<Array<any>>([])
  const apiKey = `${process.env.REACT_APP_CROWDIN_APIKEY}`
  const projectId = parseInt(`${process.env.REACT_APP_CROWDIN_PROJECTID}`)
  const fileId = 6
  const credentials: Credentials = {
    token: apiKey
  }
  const { pippiPrice } = useHTPrice()

  const stringTranslationsApi = new StringTranslations(credentials)

  const getStoredLang = (storedLangCode: string) => {
    return allLanguages.filter(language => {
      return language.code === storedLangCode
    })[0]
  }

  useEffect(() => {
    // 更新价格
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum)

    }

  }, [])

  useEffect(() => {
    setSelectedLanguage(EN)
    const storedLangCode = cookie.getCookie('pipipSwapLanguage')
    if (storedLangCode) {
      const storedLang = getStoredLang(storedLangCode)
      setSelectedLanguage(storedLang)
    } else {
      setSelectedLanguage(EN)
    }
  }, [])

  const fetchTranslationsForSelectedLanguage = async () => {
    stringTranslationsApi
      .listLanguageTranslations(projectId, selectedLanguage.code, undefined, fileId, 200)
      .then(translationApiResponse => {
        if (translationApiResponse.data.length < 1) {
          setTranslations(['error'])
        } else {
          setTranslations(translationApiResponse.data)
        }
      })
      .then(() => setTranslatedLanguage(selectedLanguage))
      .catch(error => {
        setTranslations(['error'])
        console.error(error)
      })
  }
  const handleSetSelectedLanguage = obj => {
    setSelectedLanguage(obj)
    cookie.setCookie('pipipSwapLanguage', obj.code)
  }
  useEffect(() => {
    if (selectedLanguage) {
      fetchTranslationsForSelectedLanguage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguage])

  return (
    <Suspense fallback={null}>
      <HashRouter>
        <Route component={GoogleAnalyticsReporter} />
        <AppWrapper>
          <LanguageContext.Provider
            value={{ selectedLanguage, handleSetSelectedLanguage, translatedLanguage, setTranslatedLanguage }}
          >
            <TranslationsContext.Provider value={{ translations, setTranslations }}>
              <I18nProvider>
                <HeaderWrapper>
                  <Header />
                </HeaderWrapper>
                <BodyWrapper>
                  <Popups />
                  <Web3ReactManager>
                    <PageBg src={isMobile ? BgIcon : BgIconPc} />
                    <Switch>
                      <Route exact strict path="/swap" component={Swap} />
                      {/* <Route exact strict path="/farm" component={Farm} /> */}
                      {/* <Route exact strict path="/staking" component={Staking} /> */}
                      <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
                      <Route exact strict path="/send" component={RedirectPathToSwapOnly} />
                      <Route exact strict path="/find" component={PoolFinder} />
                      <Route exact strict path="/pool" component={Pool} />
                      <Route exact strict path="/create" component={RedirectToAddLiquidity} />
                      <Route exact path="/add" component={AddLiquidity} />
                      <Route exact path="/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
                      <Route exact path="/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
                      <Route exact strict path="/remove/v1/:address" component={RemoveV1Exchange} />
                      <Route exact strict path="/remove/:tokens" component={RedirectOldRemoveLiquidityPathStructure} />
                      <Route exact strict path="/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
                      <Route exact strict path="/migrate/v1" component={MigrateV1} />
                      <Route exact strict path="/migrate/v1/:address" component={MigrateV1Exchange} />
                      <Route exact strict path="/pledge" component={Pledge} />
                      <Route exact strict path="/home" component={PledgeHome} />
                      <Route exact strict path="/market" component={Market} />
                      <Route exact strict path="/detail" component={Detail} />
                      <Route exact strict path="/bag" component={Bag} />
                      <Route exact strict path="/orders" component={Order} />
                      <Route exact strict path="/nft-log" component={NftLog} />
                      <Route exact strict path="/history" component={HistoryComp} />
                      <Route component={RedirectPathToSwapOnly} />
                    </Switch>
                  </Web3ReactManager>
                  {/* <LogoTitle src={LogoH} alt="bg" /> */}
                  <Marginer />
                  {/* <div id="appfooter" style={{
                    position: 'relative',
                    width: 'calc(100% + 32px)',
                    height: '627px',
                    margin: '-16px',
                    background: 'linear-gradient(201.15deg, rgba(8, 13, 13, 1) 31.32%, rgba(18, 88, 98, 1) 109.34%)'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: 16
                    }}>
                      <img style={{
                        width: 22,
                        height: 24
                      }} src={CoyIcon} alt="" />
                      <div>AngelSwap</div>
                    </div>
                  </div> */}
                </BodyWrapper>
                <Footer pippiPrice={pippiPrice} />
                {isMobile && <Tabbar />}
              </I18nProvider>
            </TranslationsContext.Provider>
          </LanguageContext.Provider>
        </AppWrapper>
      </HashRouter>
    </Suspense>
  )
}

const Footer = ({ pippiPrice }) => {

  const location = useLocation()

  if (isNewPage(location.pathname)) {
    return null
  }

  return (isMobile ? <>
    <div style={{
      position: 'relative',
      width: '100%',
      padding: '0 17px',
      zIndex: 2
    }}>
      <div style={{
        color: 'rgb(35, 132, 126)',
        fontSize: 22,
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        wordBreak: 'break-word'
      }}>
        <div>Bridge assets to CORE Chain</div>
        <img style={{
          width: 24,
          marginLeft: 10
        }} src={IconArrow} alt="" />
      </div>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '12px 0 24px'
      }}>
        <img style={{
          width: 114
        }} src={IconBubble} alt="" />
        <img style={{
          width: 65
        }} src={IconCat} alt="" />
      </div>
    </div>
    <div id="appfooter" style={{
      position: 'relative',
      width: '100%',
      height: '627px',
      padding: '0 17px',
      margin: '0 0 -16px',
      zIndex: 2,
      background: 'linear-gradient(25deg, rgb(18, 88, 98) 1%, rgb(8, 13, 13))'
      // background: 'linear-gradient(to right top, rgb(18, 88, 98) 1%, rgb(8, 13, 13))'
      // background: 'linear-gradient(201.15deg, rgba(8, 13, 13, 1) 31.32%, rgba(18, 88, 98, 1) 109.34%)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 0',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '16px',
        borderBottom: '1px solid rgb(48, 213, 193)'
      }}>
        <img style={{
          width: 24,
          height: 24,
          marginRight: 9
        }} src={CoyIcon} alt="" />
        <div>AngelSwap</div>
      </div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 0'
      }}>
        <img style={{
          width: 24,
          height: 24,
          marginRight: 9
        }} src={CoyIcon} alt="" />
        <div style={{
          flex: 1,
          fontSize: 15,
          color: 'rgba(164, 193, 202, 1)'
        }}>${pippiPrice.toFixed(3)}</div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          background: 'rgb(35, 132, 126)',
          width: '116px',
          height: '28px',
          paddingLeft: 8,
          fontSize: '13px',
          fontWeight: 'bold',
          borderRadius: '14px',
          boxSizing: 'border-box'
        }}>
          Buy ANGEL
        </div>
      </div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        height: 64,
        width: '100%',
        borderBottom: '1px solid rgba(48, 213, 193, 1)'
      }}>
        <LngSHome />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: 140,
          padding: '16px 0',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          color: 'rgba(31, 255, 255, 1)',
          fontSize: 17,
          fontWeight: 'bold'
        }}>关于</div>
        <div>联系我们</div>
        <div>博客</div>
        <div>CoreDao</div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: 112,
          padding: '16px 0',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          color: 'rgba(31, 255, 255, 1)',
          fontSize: 17,
          fontWeight: 'bold'
        }}>帮助</div>
        <div>指南</div>
        <div>CoreDao</div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: 140,
          padding: '16px 0',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          color: 'rgba(31, 255, 255, 1)',
          fontSize: 17,
          fontWeight: 'bold'
        }}>开发者</div>
        <div>Github</div>
        <div>文档</div>
        <div>Core Network Docs</div>
      </div>
    </div>
  </> : <div id="appfooter" style={{
    position: 'relative',
    width: '100%',
    padding: '0 17px',
    zIndex: 2,
    background: 'linear-gradient(to bottom, rgb(8, 13, 13), rgb(18, 88, 98))'
    // background: 'linear-gradient(to right top, rgb(18, 88, 98) 1%, rgb(8, 13, 13))'
    // background: 'linear-gradient(201.15deg, rgba(8, 13, 13, 1) 31.32%, rgba(18, 88, 98, 1) 109.34%)'
  }}>
    <div style={{
      position: 'absolute',
      bottom: '100%',
      left: 0,
      right: 0,
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        maxWidth: 1200,
        margin: '0 auto'
      }}>
        <div style={{
          color: 'rgb(35, 132, 126)',
          fontSize: 16,
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 25
        }}>
          <div>Bridge assets to CORE Chain</div>
          <img style={{
            width: 24,
            marginLeft: 10
          }} src={IconArrow} alt="" />
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '12px 0 24px'
        }}>
          <img style={{
            width: 114
          }} src={IconBubble} alt="" />
          <img style={{
            width: 65
          }} src={IconCat} alt="" />
        </div>
      </div>
    </div>
    <div style={{
      display: 'flex',
      maxWidth: 1200,
      margin: '0 auto',
      padding: '50px 0 40px',
      borderBottom: '1px solid rgb(31, 255, 255)'
    }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: 160,
          flex: 1,
          padding: '16px 0',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          color: 'rgba(31, 255, 255, 1)',
          fontSize: 17,
          fontWeight: 'bold'
        }}>关于</div>
        <div>联系我们</div>
        <div>博客</div>
        <div>CoreDao</div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: 132,
          flex: 1,
          padding: '16px 0',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          color: 'rgba(31, 255, 255, 1)',
          fontSize: 17,
          fontWeight: 'bold'
        }}>帮助</div>
        <div>指南</div>
        <div>CoreDao</div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: 160,
          flex: 1,
          padding: '16px 0',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          color: 'rgba(31, 255, 255, 1)',
          fontSize: 17,
          fontWeight: 'bold'
        }}>开发者</div>
        <div>Github</div>
        <div>文档</div>
        <div>Core Network Docs</div>
      </div>
      <div
        style={{
          display: 'flex',
          height: 140,
          flex: 1,
          padding: '16px 0',
          boxSizing: 'border-box'
        }}
      >
        <img style={{
          width: 22,
          height: 24,
          marginRight: 9
        }} src={CoyIcon} alt="" />
        <div>AngelSwap</div>
      </div>
    </div>
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: 1200,
      margin: '30px auto'
    }}>
      <LngSHome />
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <div style={{
          flex: 1,
          fontSize: 15,
          color: 'rgba(164, 193, 202, 1)',
          marginRight: 20
        }}>${pippiPrice.toFixed(3)}</div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          background: 'rgb(35, 132, 126)',
          width: '116px',
          height: '28px',
          paddingLeft: 8,
          fontSize: '13px',
          fontWeight: 'bold',
          borderRadius: '14px',
          boxSizing: 'border-box'
        }}>
          Buy ANGEL
        </div>
      </div>
    </div>
  </div>)
}